import { lazy } from 'react';

const Input = lazy(() => import('./Input'));

export { Input };
